import React from 'react';
import { VendorManagementViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: VendorManagementViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
